import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericService } from 'src/app/generic.service';
import { ScreenSize } from 'src/app/models';

@Component({
  selector: 'app-view-dialog',
  templateUrl: './view-dialog.component.html',
  styles: [
  ]
})
export class ViewDialogComponent implements OnInit {
  size: ScreenSize;
  path = '';
  filename: string;
  loading = false;
  constructor(public dialogRef: MatDialogRef<ViewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private service: GenericService) {
    this.size = service.size;
  }

  ngOnInit(): void {
    this.loading = true;
    this.service.getData('Gfile/GetGFile/' + this.data.gkey).then(response => {
      this.path = response.dto.path;
      this.filename = response.dto.fileName;
      this.loading = false;
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  newTab(): void {
    window.open(this.path, '_blank');
  }

}
